/*!
=========================================================
* Material Dashboard PRO React - v1.10.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import AuthLayout from "layouts/Auth.js";
import RtlLayout from "layouts/RTL.js";
import AdminLayout from "layouts/Admin.js";
import AccountLayout from "layouts/Account.js";

import "./index.css";
import "assets/scss/material-dashboard-pro-react.scss?v=1.10.0";

// 🔥 Import the service worker registration file
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const root = createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Switch>
      <Route path="/rtl" component={RtlLayout} />
      <Route path="/auth" component={AuthLayout} />
      <Route path="/singles" component={AdminLayout} />
      <Route path="/account" component={AccountLayout} />
      {/* The backend's PayPal views redirect to /payment/<result>?... */}
      <Route
        path="/payment/:result"
        render={({ match, location }) => (
          <Redirect to={`/auth/payment/${match.params.result}${location.search}`} />
        )}
      />
      <Redirect from="/" to="/singles/dashboard" />
    </Switch>
  </BrowserRouter>
);

// ✅ Enable service worker for PWA
serviceWorkerRegistration.register();
